import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './_admin';

// Code splitting: Lazy load AlbumsPage to reduce initial bundle size
const AlbumsPage = lazy(() => import('@/pages/admin/AlbumsPage'));

/**
 * Admin albums list route - /admin/albums
 * Shows paginated list of all albums across all users
 */
export const adminAlbumsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: 'albums',
  component: AlbumsPage,
});

// Backward compatibility
export const Route = adminAlbumsRoute;
